import { Routes } from '~/config';

/** Path under a workspace, e.g. `/ws/policy-engine/groups`. */
export function policyEnginePath(workspaceId: string, suffix = '') {
  const path = !suffix ? '' : suffix.startsWith('/') ? suffix : `/${suffix}`;
  return `/${workspaceId}${Routes.POLICY_ENGINE}${path}`;
}

/** Absolute portal URL for MCP / email, e.g. `https://app.../ws/policy-engine/groups`. */
export function policyEngineAbsoluteUrl(baseUrl: string, workspaceId: string, suffix = '') {
  return `${baseUrl.replace(/\/$/, '')}${policyEnginePath(workspaceId, suffix)}`;
}
